import { DisplayNodeController } from "../../../utils/DisplayNodeController";
import { SubnetOutputSopNode } from "../../SubnetOutput";
import { CoreGraphNode } from "../../../../../core/graph/CoreGraphNode";
import { TypedSopNode } from "../../_Base";
import { NodeContext } from "../../../../poly/NodeContext";
export class SubnetSopNodeLike extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.childrenDisplayController = new SopSubnetChildrenDisplayController(this);
    this.displayNodeController = new DisplayNodeController(this, this.childrenDisplayController.displayNodeControllerCallbacks());
    this._childrenControllerContext = NodeContext.SOP;
  }
  initializeBaseNode() {
    super.initializeBaseNode();
    this.childrenDisplayController.initializeNode();
    this.cookController.disallowInputsEvaluation();
  }
  createNode(node_class, options) {
    return super.createNode(node_class, options);
  }
  children() {
    return super.children();
  }
  nodesByType(type) {
    return super.nodesByType(type);
  }
  async cook(input_contents) {
    const child_output_node = this.childrenDisplayController.outputNode();
    if (child_output_node) {
      const container = await child_output_node.compute();
      const core_content = container.coreContent();
      if (core_content) {
        this.setCoreGroup(core_content);
      } else {
        if (child_output_node.states.error.active()) {
          this.states.error.set(child_output_node.states.error.message());
        } else {
          this.setObjects([]);
        }
      }
    } else {
      this.states.error.set("no output node found inside subnet");
    }
  }
}
const DEFAULT_OPTIONS = {
  dependsOnDisplayNode: true
};
export class SopSubnetChildrenDisplayController {
  constructor(node, options = DEFAULT_OPTIONS) {
    this.node = node;
    this.options = options;
    this._outputNodeNeedsUpdate = true;
  }
  dispose() {
    var _a;
    (_a = this._graphNode) == null ? void 0 : _a.dispose();
  }
  displayNodeControllerCallbacks() {
    return {
      onDisplayNodeRemove: () => {
        this.node.setDirty();
      },
      onDisplayNodeSet: () => {
        this.node.setDirty();
      },
      onDisplayNodeUpdate: () => {
        this.node.setDirty();
      }
    };
  }
  outputNode() {
    if (this._outputNodeNeedsUpdate) {
      this._updateOutputNode();
    }
    return this._outputNode;
  }
  initializeNode() {
    var _a;
    const display_flag = (_a = this.node.flags) == null ? void 0 : _a.display;
    if (display_flag) {
      display_flag.onUpdate(() => {
        if (display_flag.active()) {
          this.node.setDirty();
        }
      });
    }
    this.node.lifecycle.onChildAdd(() => {
      this._outputNodeNeedsUpdate = true;
      this.node.setDirty();
    });
    this.node.lifecycle.onChildRemove(() => {
      this._outputNodeNeedsUpdate = true;
      this.node.setDirty();
    });
  }
  _updateOutputNode() {
    const foundNode = this.node.nodesByType(SubnetOutputSopNode.type())[0];
    if (this._outputNode == null || foundNode == null || this._outputNode.graphNodeId() != foundNode.graphNodeId()) {
      if (this._graphNode && this._outputNode) {
        this._graphNode.removeGraphInput(this._outputNode);
      }
      this._outputNode = foundNode;
      if (this._outputNode && this.options.dependsOnDisplayNode) {
        this._graphNode = this._graphNode || this._createGraphNode();
        this._graphNode.addGraphInput(this._outputNode);
      }
    }
  }
  _createGraphNode() {
    const graph_node = new CoreGraphNode(this.node.scene(), "subnetChildrenDisplayController");
    graph_node.addPostDirtyHook("subnetChildrenDisplayController", () => {
      this.node.setDirty();
    });
    return graph_node;
  }
}
